/*
 * Update payout details.  
 * This calls a postgres function with approval details that will update the details and recalc the payout.
 */
import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation PayoutDetailUpdateMutation($input:  UpdatevendorpayoutchargeapprovalsInput!) {
    updatevendorpayoutchargeapprovals(input: $input) {
      integer
    }
  }
  `;
    
  function commit(vendorAccountId, vendorPayoutId, resellerProgramId, vendorChargeApprovalDetails) {
    var variables = {
        input: {
            vendoraccountid : vendorAccountId,
            vendorpayoutid : vendorPayoutId,
            resellerprogramid: resellerProgramId,
            vendorchargeapprovaldetails: vendorChargeApprovalDetails
        }
    };

    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: (response) => {
          resolve(response);
        },
        onError: (error) => {
          reject(error);
        }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
 